'use client';
import SliderHand from '@components/slider-hand/SliderHand';
import HorizontalScrollInfraInfraMob from '@components/slider-Infrastructure/HorizontalScrollInfraInfraMob';
import { ScrollTrigger } from '@lib/tools/gsap-init';
import { useViewport } from '@lib/tools/hooks/useViewport';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import style from './SixthScreenInfra.module.scss';

function SixthScreenInfraMob() {
  const { isMobile, isTablet, viewport, isPortrait, isLandscape, userAgent } = useViewport();
  const svgRef = useRef(null);

  const [toggle, setToggle] = useState(false);
  const [st18, setSt18] = useState(null);

  useLayoutEffect(() => {
    let st18;
    if (viewport && !toggle) {
      const element = svgRef.current;

      st18 = setTimeout(() => {
        setSt18(
          ScrollTrigger.create({
            trigger: element,
            id: 'fall',
            start: 'top center', // end: "bottom bottom",
            scroller: !isMobile ? '#smooth-wrapper' : 'body',
            scrub: true,
            pin: false,
            onToggle: () => {
              setTimeout(() => {
                setToggle(() => true);
              }, 500);
            },
          }),
        );
      }, 1000);
    }

    return () => {
      if (st18) {
        clearTimeout(st18);
      }
    };
  }, [svgRef, isMobile]);

  useEffect(() => {
    return () => {
      if (st18) st18.kill();
      setSt18(null);
      ScrollTrigger.getById('fall')?.kill();
    };
  }, []);

  const isAdaptive = isMobile || isTablet;
  const isAdaptivePortrait = isAdaptive && isPortrait;
  const isAdaptiveLandscape = isAdaptive && isLandscape;

  const hiddenSliderHand = isAdaptivePortrait || (isAdaptiveLandscape && userAgent === 'none');

  return (
    <div ref={svgRef} data-scroll className={style.fourthScreenContainer}>
      <div className={style.fourthScreenWrapper}>
        <div className={style.fourthScreenTextBox}>
          <div data-scroll data-scroll-speed='0.5' className={style.fourthScreenTitle}>
            Ведите дневник <br /> впечатлений
            <br />
          </div>
          <div data-scroll data-scroll-speed='0.5' className={style.fourthScreenDescription}>
            Вариантов, как провести день в&nbsp;Моментс, так&nbsp;же много, как извилистых тропинок. Смысловые
            пространства учитывают интересы&nbsp;резидентов&nbsp;разного&nbsp;возраста{' '}
          </div>
        </div>
      </div>
      <SliderHand orientation='right' hidden={!hiddenSliderHand} />
      <HorizontalScrollInfraInfraMob />
    </div>
  );
}

export default SixthScreenInfraMob;
